import useUserStorage from '../storage/user/hook';
import { isRegisteredUser } from '../storage/user/utils';
export default function useIsRegisteredUser() {
    const [userDetails] = useUserStorage();
    return isRegisteredUser(userDetails);
}
